
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/article",
      function () {
        return require("private-next-pages/news/article.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/article"])
      });
    }
  